import { FC, useState, ChangeEvent } from 'react';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { setAnswers, setQuestionEnd, setQuestionStart } from 'store/player/playerSlice';
import { selectQuestion } from 'store/quiz/quizSelectors';
import IQuestion from 'models/Question';
import { IAnswerResult } from 'models/Answer';
// Component
import { Button } from 'components/Buttons';
import { Input } from 'components/Controls';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  score: number;
  time: number;
  disabled?: boolean;
};

const ScoreAnswers:FC<Props> = ({ score, time, disabled = false }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const question:IQuestion = useAppSelector(selectQuestion);

  const [ clicked, setClicked ] = useState<boolean>(false);

  const [ firstScore, setFirstScore ] = useState<string>('');
  const [ secondScore, setSecondScore ] = useState<string>('');

  const handleTitle = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === 'question-game-score-1') {
      setFirstScore(`${value}`);
    } else {
      setSecondScore(`${value}`);
    }
  }

  const handleSubmit = () => {
      if (clicked) return;
    
      dispatch(setQuestionStart(false));
  
      const nextAnswer:IAnswerResult = {
        type: question.type,
        score,
        time,
        question: {
          ref: question.ref,
          title: question.title
        },
        input: {
          text: `${firstScore}-${secondScore}`
        }
      }
  
      dispatch(setAnswers([nextAnswer]));
      dispatch(setQuestionEnd(true));
  
      setClicked(true);
  }

  return (
    <div>
      <div className="flex gap-4">
        <Input
          name="question-game-score-1" id="question-game-score-1"
          placeholder={question.scorePlaceholder1 || t('labels.numberedScore', { number: 1 })}
          value={firstScore}
          onChange={handleTitle}
          disabled={disabled || clicked}
          type="number"
        />
        <Input
          name="question-game-score-2" id="question-game-score-2"
          placeholder={question.scorePlaceholder2 || t('labels.numberedScore', { number: 2 })}
          value={secondScore}
          onChange={handleTitle}
          disabled={disabled || clicked}
          type="number"
        />
      </div>
      <Button
        className="w-full text-xl uppercase primary-button"
        onClick={handleSubmit}
        disabled={!firstScore.trim() || !secondScore.trim() || clicked}
      >
        {t('buttons.next')}
      </Button>
    </div>
  )
}

export default ScoreAnswers;
